<template>
    <section class="clients-section">
<!--        <h3 class="text-center">{{title|tr}}</h3>-->
        <div class="clients">
            <slot></slot>
        </div>
    </section>
</template>

<script>
    export default {
        name: `clients-section`,
        props: {
            title: { type: String, required: true }
        }
    }
</script>

<style lang="scss" scoped>
    .clients-section {

    }

    @media(max-width: 576px) {
        .clients-section {
            .clients {
                margin-left: -8%;
                margin-right: -8%;
            }
        }
    }
</style>
